import type { WebGLRenderer } from "three"
import getSetEngineWeakMapFactory from "./getSetEngineWeakMapFactory"

export const [getEngineThreeMainRenderer, setEngineThreeMainRenderer] = getSetEngineWeakMapFactory<WebGLRenderer>()
